<script setup lang="ts">
import { alertVariants } from '.'
import { cn } from '@/lib/utils'

interface Props {
  variant?: NonNullable<Parameters<typeof alertVariants>[0]>['variant']
}

defineProps<Props>()
</script>

<template>
  <div
    :class="cn(alertVariants({ variant }), $attrs.class ?? '')"
    role="alert"
  >
    <slot />
  </div>
</template>
